import { createSlice } from '@reduxjs/toolkit';
import { createApi } from '../../utils/api';

export const getBuyerForecastHistoryNotificationsUnreadCountSlice = createApi('GetBuyerForecastHistoryNotificationsUnreadCountSlice', 'GET');

const GetBuyerForecastHistoryNotificationsUnreadCountSlice = createSlice({
  name: 'GetBuyerForecastHistoryNotificationsUnreadCountSlice',
  initialState: {
    data: 0,
    loading: false,
    error: null,
  },
  reducers: {},
  extraReducers: (builder) => {
    builder
      .addCase(getBuyerForecastHistoryNotificationsUnreadCountSlice.pending, (state) => {
        state.loading = true;
        state.error = null;
      })
      .addCase(getBuyerForecastHistoryNotificationsUnreadCountSlice.fulfilled, (state, action) => {
        state.loading = false;
        state.data = action.payload;
      })
      .addCase(getBuyerForecastHistoryNotificationsUnreadCountSlice.rejected, (state, action) => {
        state.loading = false;
        state.error = action.payload;
      });
  },
});

export default GetBuyerForecastHistoryNotificationsUnreadCountSlice.reducer;
